import React, { ErrorInfo } from 'react';

import * as Sentry from '@sentry/browser';
import Router from 'next/router';

const IS_PROD = process.env.NEXT_PUBLIC_BUILD_TYPE === 'PRODUCTION';

class ErrorBoundary extends React.Component<React.PropsWithChildren> {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (IS_PROD) {
      try {
        Sentry.withScope((scope) => {
          scope.setExtras(errorInfo as any);
          const eventId = Sentry.captureException(error);
          Router.push(`/500${eventId ? '?eventId=' + eventId : ''}`);
        });
      } catch (e) {
        console.log({ error, errorInfo });
        Router.push(`/500`);
      }
    } else {
      console.log({ error, errorInfo });
      Router.push('/500');
    }
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
